import React from "react";

interface PromoIconProps {
  index: number;
}

const PromoIcon: React.FC<PromoIconProps> = ({ index }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84"
      height="84"
      viewBox="0 0 84 84"
      fill="none"
    >
      <g filter="url(#filter0_i_350_7081)">
        <rect
          width="59.397"
          height="59.397"
          transform="translate(42) rotate(45)"
          fill="#4DA1A9"
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          fontSize="24"
          dy=".3em"
          fill="#ffffff"
        >
          {index + 1}
        </text>
      </g>
      <rect
        x="8.82227"
        y="33.6582"
        width="11.8794"
        height="11.8794"
        transform="rotate(45 8.82227 33.6582)"
        fill="#FF8F00"
      />
      <defs>
        <filter
          id="filter0_i_350_7081"
          x="0"
          y="0"
          width="84"
          height="84"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-8" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_350_7081"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default PromoIcon;
